import { render } from "./PassengerSelect.vue?vue&type=template&id=80d2681a&scoped=true&lang=pug"
import script from "./PassengerSelect.vue?vue&type=script&lang=ts"
export * from "./PassengerSelect.vue?vue&type=script&lang=ts"

import "./PassengerSelect.vue?vue&type=style&index=0&id=80d2681a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-80d2681a"

export default script